import { Routes, Route } from "react-router-dom";
import { AuthenticatedTemplate } from "@azure/msal-react";
import AccessDenied from "./AccessDenied";

export default function ProtectedRoutes({ children, msalInstance }) {
  const roles = ["user"];

  if (roles?.includes("user")) return children;
  return (
    <AuthenticatedTemplate>
      <Routes>
        <Route path="*" element={<AccessDenied />} />
      </Routes>
    </AuthenticatedTemplate>
  );
}
